var _style, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgP1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M855.8,1000H144.2C64.56,1000,0,935.44,0,855.8V144.2C0,64.56,64.56,0,144.2,0H855.8 C935.44,0,1000,64.56,1000,144.2V855.8C1000,935.44,935.44,1000,855.8,1000z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 90,
    height: 90
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 140,
    width: 90,
    height: 90
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 230,
    width: 90,
    height: 90
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 410,
    width: 90,
    height: 90
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 770,
    width: 90,
    height: 90
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 860,
    width: 90,
    height: 90
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 50,
    width: 90,
    height: 90
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 230,
    width: 90,
    height: 90
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 410,
    width: 90,
    height: 90
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 500,
    width: 90,
    height: 90
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 860,
    width: 90,
    height: 90
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 50,
    width: 90,
    height: 90
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 140,
    width: 90,
    height: 90
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 500,
    width: 90,
    height: 90
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 590,
    width: 90,
    height: 90
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 770,
    width: 90,
    height: 90
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 50,
    width: 90,
    height: 90
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 230,
    width: 90,
    height: 90
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 320,
    width: 90,
    height: 90
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 410,
    width: 90,
    height: 90
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 500,
    width: 90,
    height: 90
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 680,
    width: 90,
    height: 90
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 770,
    width: 90,
    height: 90
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 230,
    width: 90,
    height: 90
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 500,
    width: 90,
    height: 90
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 860,
    width: 90,
    height: 90
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 140,
    width: 90,
    height: 90
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 230,
    width: 90,
    height: 90
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 410,
    width: 90,
    height: 90
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 770,
    width: 90,
    height: 90
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 140,
    width: 90,
    height: 90
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 500,
    width: 90,
    height: 90
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 590,
    width: 90,
    height: 90
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 680,
    width: 90,
    height: 90
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 770,
    width: 90,
    height: 90
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 860,
    width: 90,
    height: 90
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 140,
    width: 90,
    height: 90
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 230,
    width: 90,
    height: 90
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 500,
    width: 90,
    height: 90
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 680,
    width: 90,
    height: 90
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 770,
    y: 50,
    width: 90,
    height: 90
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 770,
    y: 140,
    width: 90,
    height: 90
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 770,
    y: 410,
    width: 90,
    height: 90
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 770,
    y: 500,
    width: 90,
    height: 90
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 50,
    width: 90,
    height: 90
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 230,
    width: 90,
    height: 90
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 320,
    width: 90,
    height: 90
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 410,
    width: 90,
    height: 90
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 500,
    width: 90,
    height: 90
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 860,
    width: 90,
    height: 90
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP1);
export default __webpack_public_path__ + "static/media/P1.f3a697ccd8588eb16abe03bc36361c95.svg";
export { ForwardRef as ReactComponent };